/* Auto generated file */
/* eslint-disable */
import { SVGIconSprite, type SVGIconSpriteProps } from '../icon/SVGIconSprite';

const Menu = (props: SVGIconSpriteProps) =>
    <SVGIconSprite {...props} icon="menu" />;

export { Menu, Menu as default };
